"use strict";
Object.defineProperty(exports, "__esModule", { value: true });



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/containers/Collapse/CollapseProps.js
// module id = 1842
// module chunks = 8